import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export function auctionsReportQueryOptions(storeId: string, { from, to }: DayRange) {
  return infiniteQueryOptions({
    queryKey: reportKeys.auctions(storeId, { from, to }),
    queryFn: ({ pageParam }) => reportsApi.auctions(storeId, { from, to }, pageParam ?? undefined),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
    placeholderData: keepPreviousData,
  });
}

export function useAuctionsReport(storeId: string, range: DayRange) {
  return useInfiniteQuery(auctionsReportQueryOptions(storeId, range));
}
